import { render, staticRenderFns } from "./TheModalTipoInternacion.vue?vue&type=template&id=60bd504d&scoped=true&"
import script from "./TheModalTipoInternacion.vue?vue&type=script&lang=js&"
export * from "./TheModalTipoInternacion.vue?vue&type=script&lang=js&"
import style0 from "./TheModalTipoInternacion.vue?vue&type=style&index=0&id=60bd504d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bd504d",
  null
  
)

export default component.exports